"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.initialState = void 0;
const fp = require("fp-ts");
const monocle = require("monocle-ts");
const Actions = require("../../actionTypes/user/userSettings");
const status_1 = require("../../status");
//#region INITIALSTATE
exports.initialState = {
    isOpen: false,
    user: fp.option.none,
    mode: 'USER',
    currentTabIndex: 0,
    userInfo: {
        firstName: '',
        lastName: '',
        avatar: '',
        title: '',
        telephone: '',
        street: '',
        postalCode: '',
        city: '',
        country: ''
    },
    sendAuthenticationCodeStatus: new status_1.RequestStatus(status_1.RequestType.UPDATE),
    resetPasswordStatus: new status_1.RequestStatus(status_1.RequestType.UPDATE),
    updateProfileStatus: new status_1.RequestStatus(status_1.RequestType.UPDATE),
    changeCompanyStatus: new status_1.RequestStatus(status_1.RequestType.UPDATE),
    removeUserStatus: new status_1.RequestStatus(status_1.RequestType.UPDATE),
    changePasswordStatus: new status_1.RequestStatus(status_1.RequestType.UPDATE),
    customers: [],
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
    onCloseActions: [],
    validation: {
        status: 'NONE'
    },
    newEmail: '',
    changeEmailStatus: new status_1.RequestStatus(status_1.RequestType.UPDATE),
    consents: {
        status: new status_1.RequestStatus(),
        value: null,
        error: null
    }
};
//#endregion
const isOpenLens = monocle.Lens.fromProp('isOpen');
const userLens = monocle.Lens.fromProp('user');
const modeLens = monocle.Lens.fromProp('mode');
const userInfoLens = monocle.Lens.fromProp('userInfo');
const updateProfileStatusLens = monocle.Lens.fromProp('updateProfileStatus');
const updateProfileErrorsLens = monocle.Lens.fromProp('updateProfileErrors');
const changeCompanyStatusLens = monocle.Lens.fromProp('changeCompanyStatus');
const changeCompanyErrorsLens = monocle.Lens.fromProp('changeCompanyErrors');
const onCloseActionsLens = monocle.Lens.fromProp('onCloseActions');
const changePasswordStatusLens = monocle.Lens.fromProp('changePasswordStatus');
const oldPasswordLens = monocle.Lens.fromProp('oldPassword');
const newPasswordLens = monocle.Lens.fromProp('newPassword');
const confirmPasswordLens = monocle.Lens.fromProp('confirmPassword');
const validationLens = monocle.Lens.fromProp('validation');
const newEmailLens = monocle.Lens.fromProp('newEmail');
const changeEmailLens = monocle.Lens.fromProp('changeEmailStatus');
const consentsLens = monocle.Lens.fromProp('consents');
const methods = {};
exports.methods = methods;
methods[Actions.OPEN_USER_SETTINGS_MODAL] = (state, action) => fp.function.flow(isOpenLens.set(true), userLens.set(fp.option.some(action.payload.user)), modeLens.set(action.payload.mode), onCloseActionsLens.set(action.payload.onCloseActions), userInfoLens.modify(() => {
    const det = action.payload.user.addressDetails;
    const userInfo = {
        firstName: action.payload.user.firstName || '',
        lastName: action.payload.user.lastName || '',
        avatar: action.payload.user.avatar || 'Grano_SokoPro_avatar_0',
        title: det.title || '',
        telephone: det.telephone || '',
        street: det.street || '',
        postalCode: det.postalCode || '',
        city: det.city || '',
        country: det.country || ''
    };
    return userInfo;
}))(state);
methods[Actions.CLOSE_USER_SETTINGS_MODAL] = (state, action) => (Object.assign({}, exports.initialState));
methods[Actions.CHANGE_TAB] = (state, action) => (Object.assign(Object.assign({}, state), { currentTabIndex: action.payload }));
methods[Actions.UPDATE_VALUE] = (state, action) => userInfoLens.modify((x) => {
    const clone = Object.assign({}, x);
    clone[action.payload.field] = action.payload.value;
    return clone;
})(state);
methods[Actions.UPDATE_PASSWORD_VALUE] = (state, action) => {
    switch (action.payload.field) {
        case 'oldPassword':
            return oldPasswordLens.set(action.payload.value)(state);
        case 'newPassword':
            return newPasswordLens.set(action.payload.value)(state);
        case 'confirmPassword':
            return confirmPasswordLens.set(action.payload.value)(state);
        default:
            return state;
    }
};
methods[Actions.RESEND_AUTHENTICATION_CODE_REQUEST] = (state, action) => (Object.assign(Object.assign({}, state), { sendAuthenticationCodeStatus: new status_1.RequestStatus(status_1.RequestType.UPDATE, status_1.RequestStatusValue.BUSY), sendAuthenticationCodeErrors: undefined }));
methods[Actions.RESEND_AUTHENTICATION_CODE_FAILURE] = (state, action) => (Object.assign(Object.assign({}, state), { sendAuthenticationCodeStatus: new status_1.RequestStatus(status_1.RequestType.UPDATE, status_1.RequestStatusValue.FAILURE), sendAuthenticationCodeErrors: action.payload }));
methods[Actions.RESEND_AUTHENTICATION_CODE_SUCCESS] = (state, action) => (Object.assign(Object.assign({}, state), { sendAuthenticationCodeStatus: new status_1.RequestStatus(status_1.RequestType.UPDATE, status_1.RequestStatusValue.SUCCESS), sendAuthenticationCodeErrors: undefined }));
methods[Actions.UPDATE_MEMBER_INFO_REQUEST] = (state, action) => fp.function.flow(updateProfileStatusLens.set(new status_1.RequestStatus(status_1.RequestType.UPDATE, status_1.RequestStatusValue.BUSY)), updateProfileErrorsLens.set(undefined), validationLens.set({ status: 'NONE' }))(state);
methods[Actions.UPDATE_MEMBER_INFO_FAILURE] = (state, action) => fp.function.flow(updateProfileStatusLens.set(new status_1.RequestStatus(status_1.RequestType.UPDATE, status_1.RequestStatusValue.FAILURE)), updateProfileErrorsLens.set(action.payload))(state);
methods[Actions.UPDATE_MEMBER_INFO_VALIDATION] = (state, action) => fp.function.flow(updateProfileStatusLens.set(new status_1.RequestStatus(status_1.RequestType.UPDATE, status_1.RequestStatusValue.FAILURE)), validationLens.set({
    status: 'ERROR',
    errors: action.payload.reduce((rv, x) => {
        ;
        (rv[x.key] = rv[x.key] || []).push(x.value);
        return rv;
    }, {})
}))(state);
methods[Actions.UPDATE_MEMBER_INFO_SUCCESS] = (state, action) => updateProfileStatusLens.set(new status_1.RequestStatus(status_1.RequestType.UPDATE, status_1.RequestStatusValue.SUCCESS))(state);
// Reset password
methods[Actions.RESET_PASSWORD_REQUEST] = (state, action) => (Object.assign(Object.assign({}, state), { resetPasswordStatus: new status_1.RequestStatus(status_1.RequestType.UPDATE, status_1.RequestStatusValue.BUSY), resetPasswordErrors: undefined }));
methods[Actions.RESET_PASSWORD_FAILURE] = (state, action) => (Object.assign(Object.assign({}, state), { resetPasswordStatus: new status_1.RequestStatus(status_1.RequestType.UPDATE, status_1.RequestStatusValue.FAILURE), resetPasswordErrors: action.payload }));
methods[Actions.RESET_PASSWORD_SUCCESS] = (state, action) => (Object.assign(Object.assign({}, state), { resetPasswordStatus: new status_1.RequestStatus(status_1.RequestType.UPDATE, status_1.RequestStatusValue.SUCCESS), resetPasswordErrors: undefined }));
// Change password
methods[Actions.CHANGE_PASSWORD_REQUEST] = (state, action) => changePasswordStatusLens.set(new status_1.RequestStatus(status_1.RequestType.UPDATE, status_1.RequestStatusValue.BUSY))(state);
methods[Actions.CHANGE_PASSWORD_FAILURE] = (state, action) => changePasswordStatusLens.set(new status_1.RequestStatus(status_1.RequestType.UPDATE, status_1.RequestStatusValue.FAILURE))(state);
methods[Actions.CHANGE_PASSWORD_SUCCESS] = (state, action) => changePasswordStatusLens.set(new status_1.RequestStatus(status_1.RequestType.UPDATE, status_1.RequestStatusValue.SUCCESS))(state);
// Remove user
methods[Actions.REMOVE_USER_REQUEST] = (state, action) => (Object.assign(Object.assign({}, state), { removeUserStatus: new status_1.RequestStatus(status_1.RequestType.UPDATE, status_1.RequestStatusValue.BUSY), removeUserErrors: undefined }));
methods[Actions.REMOVE_USER_FAILURE] = (state, action) => (Object.assign(Object.assign({}, state), { removeUserStatus: new status_1.RequestStatus(status_1.RequestType.UPDATE, status_1.RequestStatusValue.FAILURE), removeUserErrors: action.payload }));
methods[Actions.REMOVE_USER_SUCCESS] = (state, action) => (Object.assign(Object.assign({}, state), { removeUserStatus: new status_1.RequestStatus(status_1.RequestType.UPDATE, status_1.RequestStatusValue.SUCCESS), removeUserErrors: undefined }));
//#endregion
methods[Actions.FETCH_CUSTOMERS_SUCCESS] = (state, action) => (Object.assign(Object.assign({}, state), { customers: action.payload.customers }));
methods[Actions.SET_CUSTOMER] = (state, action) => (Object.assign(Object.assign({}, state), { company: action.payload.customer }));
methods[Actions.UPDATE_USER_COMPANY] = (state, action) => fp.function.flow(changeCompanyStatusLens.set(new status_1.RequestStatus(status_1.RequestType.UPDATE, status_1.RequestStatusValue.BUSY)), changeCompanyErrorsLens.set(undefined))(state);
methods[Actions.UPDATE_USER_COMPANY_SUCCESS] = (state, action) => changeCompanyStatusLens.set(new status_1.RequestStatus(status_1.RequestType.UPDATE, status_1.RequestStatusValue.SUCCESS))(state);
methods[Actions.UPDATE_USER_COMPANY_FAILURE] = (state, action) => fp.function.flow(changeCompanyStatusLens.set(new status_1.RequestStatus(status_1.RequestType.UPDATE, status_1.RequestStatusValue.FAILURE)), changeCompanyErrorsLens.set(action.payload))(state);
methods[Actions.SET_NEW_EMAIL] = (state, action) => newEmailLens.set(action.payload.newEmail)(state);
methods[Actions.UPDATE_EMAIL] = (state) => changeEmailLens.set(new status_1.RequestStatus(status_1.RequestType.UPDATE, status_1.RequestStatusValue.BUSY))(state);
methods[Actions.UPDATE_EMAIL_SUCCESS] = (state) => changeEmailLens.set(new status_1.RequestStatus(status_1.RequestType.UPDATE, status_1.RequestStatusValue.SUCCESS))(state);
methods[Actions.UPDATE_EMAIL_FAILURE] = (state) => changeEmailLens.set(new status_1.RequestStatus(status_1.RequestType.UPDATE, status_1.RequestStatusValue.FAILURE))(state);
methods[Actions.FETCH_OR_UPDATE_USER_CONSENTS_REQUEST] = (state, { payload }) => consentsLens.set({
    status: new status_1.RequestStatus(payload.consents ? status_1.RequestType.UPDATE : status_1.RequestType.FETCH, status_1.RequestStatusValue.BUSY),
    value: null,
    error: null
})(state);
methods[Actions.FETCH_OR_UPDATE_USER_CONSENTS_SUCCESS] = (state, { payload }) => consentsLens.set({
    status: new status_1.RequestStatus(payload.reqType, status_1.RequestStatusValue.SUCCESS),
    value: payload.consents,
    error: null
})(state);
methods[Actions.FETCH_OR_UPDATE_USER_CONSENTS_FAILURE] = (state, { payload }) => consentsLens.set({
    status: new status_1.RequestStatus(payload.reqType, status_1.RequestStatusValue.FAILURE),
    value: null,
    error: payload.error
})(state);
//# sourceMappingURL=userSettings.js.map